/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Toast_Empty_Folder_RemovedInputs */



/**
* | output |
* | --- |
* | "Empty folder \"{name}\" removed" |
*
* @param {Spaces_Toast_Empty_Folder_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_empty_folder_removed = /** @type {((inputs: Spaces_Toast_Empty_Folder_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Empty_Folder_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Leerer Ordner "${i?.name}" entfernt`)
	return /** @type {LocalizedString} */ (`Empty folder "${i?.name}" removed`)
});